import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { stills } from "@/mocks/movie";

export default function Stills() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const current = openIndex === null ? null : stills[openIndex];

  return (
    <section id="stills" className="w-full bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-16 md:py-24">
        <SectionHeading
          eyebrow="Gallery"
          title="画面预览：光影也是叙事的一部分"
          description="点击任意画面可放大查看，感受影片极具辨识度的自然光摄影风格。"
        />

        <div className="mt-12 grid sm:grid-cols-2 gap-4 md:gap-6">
          {stills.map((still, index) => (
            <button
              key={still.caption}
              type="button"
              onClick={() => setOpenIndex(index)}
              className="group text-left rounded-lg overflow-hidden border border-background-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={still.image}
                  alt={`《岳母的诱惑》剧照：${still.caption}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-foreground-950/70 text-background-50 text-xs">
                  {still.caption}
                </span>
              </div>
              <div className="flex items-center justify-between gap-3 px-5 py-4 bg-background-100">
                <p className="text-sm text-foreground-700 leading-snug">{still.text}</p>
                <i className="ri-expand-diagonal-line text-lg text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </button>
          ))}
        </div>
      </div>

      {current && (
        <div
          className="fixed inset-0 z-[60] bg-foreground-950/90 flex items-center justify-center p-4 md:p-8"
          onClick={() => setOpenIndex(null)}
        >
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <div className="w-full aspect-[3/2] rounded-lg overflow-hidden">
              <img
                src={current.image}
                alt={`《岳母的诱惑》剧照：${current.caption}`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="mt-4 flex items-center justify-between gap-4">
              <div>
                <p className="font-heading text-base font-bold text-background-50">
                  {current.caption}
                </p>
                <p className="text-sm text-background-100/70">{current.text}</p>
              </div>
              <button
                type="button"
                aria-label="关闭预览"
                onClick={() => setOpenIndex(null)}
                className="w-10 h-10 rounded-md bg-background-50/15 text-background-50 flex items-center justify-center cursor-pointer hover:bg-background-50/25 transition-colors"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}